import { useTheme } from '@kitopi-com/customer-auth';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { useAccessPoint } from 'context/AccessPointContext';
import { useEffectOnce } from 'hooks/useEffectOnce';
import { useHandleLogin } from 'hooks/useHandleLogin';
import ClipLoader from 'react-spinners/ClipLoader';

export const SignInToWifiInstant = ({ visible }: { visible: boolean }) => {
  const {
    setApAuthError,
    setIsStartAuthorizingToAP,
    setIsAuthorizationRequestSuccess,
    setIsWaitingForAuthStatus,
  } = useAccessPoint();

  const login = useHandleLogin({
    setApAuthError,
    setIsStartAuthorizingToAP,
    setIsAuthorizationRequestSuccess,
  });

  const { apAuthError, isStartAuthorizingToAP } = useAccessPoint();
  const { colors } = useTheme();

  const handleLogin = async () => {
    if (visible) {
      await login();
      setIsWaitingForAuthStatus(true);
    }
  };

  useEffectOnce(() => {
    if (!apAuthError) {
      handleLogin();
    }
  });

  if (!visible) return null;
  return (
    <div>
      <ClipLoader
        loading={isStartAuthorizingToAP && !apAuthError}
        size={40}
        color={colors?.kitopiColors.kitopiWhite ?? '#FFFFFF'}
      />

      {!!apAuthError && <ErrorDisplay errorKey={apAuthError} />}
    </div>
  );
};
